<template>
  <div class="card">
    <div class="card-header bg-success text-white">
      <h5 class="mb-0">站点配置</h5>
    </div>
    <div class="card-body">
      <div v-if="!selectedStation" class="station-config-panel">
        <div class="text-center text-muted py-5">
          请从站点列表中选择一个站点
        </div>
      </div>
      <div v-else class="station-config-panel">
        <div class="mb-3">
          <h4>{{ selectedStation.name }} 
            <span class="badge" :class="stationTypeClass">{{ stationType }}</span>
          </h4>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-md-6">
              <p><strong>站点ID:</strong> {{ selectedStation.id }}</p>
            </div>
            <div class="col-md-6">
              <p><strong>站点索引:</strong> {{ stationIndex + 1 }}/{{ totalStations }}</p>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <h5>站点配置</h5>
          <div class="row g-2">
            <div class="col-md-6">
              <div class="card h-100">
                <div class="card-body">
                  <h6 class="card-title">自定义报站语</h6>
                  <p class="card-text">
                    进站语: <span :class="selectedStation.customArrival ? 'text-success' : 'text-muted'">
                      {{ selectedStation.customArrival ? '已自定义' : '使用默认' }}
                    </span><br>
                    出站语: <span :class="selectedStation.customDeparture ? 'text-success' : 'text-muted'">
                      {{ selectedStation.customDeparture ? '已自定义' : '使用默认' }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card h-100">
                <div class="card-body">
                  <h6 class="card-title">自定义LED预览</h6>
                  <p class="card-text">
                    <small class="text-muted">进站LED:</small><br>
                    <span class="led-preview">{{ resolvedArrivalLEDContent }}</span><br>
                    <small class="text-muted">出站LED:</small><br>
                    <span class="led-preview">{{ resolvedDepartureLEDContent }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="mb-3" v-if="!hideAdvancedSettings">
          <h5>高级信息</h5>
          <div class="row g-2">
            <div class="col-md-6">
              <div class="card h-100">
                <div class="card-body">
                  <h6 class="card-title">地理位置</h6>
                  <p class="card-text small">
                    <span v-if="selectedStation.latitude && selectedStation.longitude">
                      纬度: {{ selectedStation.latitude }}<br>
                      经度: {{ selectedStation.longitude }}
                    </span>
                    <span v-else class="text-muted">未设置地理位置</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card h-100">
                <div class="card-body">
                  <h6 class="card-title">报站距离</h6>
                  <p class="card-text small">
                    进站距离: {{ selectedStation.arrivalDistance || 0 }}米<br>
                    出站距离: {{ selectedStation.departureDistance || 0 }}米
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="d-grid">
          <button class="btn btn-primary" @click="editStation">编辑站点配置</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StationConfigPanel',
  emits: ['editStation'],
  props: {
    selectedStation: {
      type: Object,
      default: null
    },
    stationIndex: {
      type: Number,
      default: -1
    },
    totalStations: {
      type: Number,
      default: 0
    },
    audioFolders: {
      type: Array,
      default: () => []
    },
    languageSettings: {
      type: Object,
      required: true
    },
    hideAdvancedSettings: {
      type: Boolean,
      default: false
    },
    ledSettings: {
      type: Object,
      required: true
    },
    upDirectionStations: {
      type: Array,
      default: () => []
    },
    downDirectionStations: {
      type: Array,
      default: () => []
    },
    currentDirection: {
      type: String,
      default: 'up'
    }
  },
  data() {
    return {};
  },
  computed: {
    stationType() {
      if (!this.selectedStation) return '';
      
      if (this.stationIndex === 0) {
        return '起点站';
      } else if (this.stationIndex === this.totalStations - 1) {
        return '终点站';
      } else {
        return '普通站';
      }
    },
    stationTypeClass() {
      if (!this.selectedStation) return '';
      
      if (this.stationIndex === 0) {
        return 'bg-success';
      } else if (this.stationIndex === this.totalStations - 1) {
        return 'bg-danger';
      } else {
        return 'bg-secondary';
      }
    },
    
    // 当前方向的站点列表
    currentStations() {
      return this.currentDirection === 'up' ? this.upDirectionStations : this.downDirectionStations;
    },
    
    // 解析进站LED内容
    resolvedArrivalLEDContent() {
      const customContent = this.selectedStation?.arrivalLEDContent;
      if (customContent && customContent.trim() !== '') {
        return this.resolvePlaceholders(customContent);
      }
      
      // 使用默认LED设置
      const defaultContent = this.ledSettings.arrivalLEDContent || '【当前站】 到了';
      return this.resolvePlaceholders(defaultContent);
    },
    
    // 解析出站LED内容
    resolvedDepartureLEDContent() {
      const customContent = this.selectedStation?.departureLEDContent;
      if (customContent && customContent.trim() !== '') {
        return this.resolvePlaceholders(customContent);
      }
      
      // 使用默认LED设置
      const defaultContent = this.ledSettings.departureLEDContent || '下一站 【当前站】';
      return this.resolvePlaceholders(defaultContent);
    }
  },
  methods: {
    editStation() {
      this.$emit('editStation', this.stationIndex);
    },
    
    // 替换占位符
    resolvePlaceholders(content) {
      if (!content || !this.selectedStation) return content;
      
      let resolvedContent = content;
      
      // 获取当前站、起点站、终点站信息
      const currentStation = this.selectedStation;
      const firstStation = this.currentStations[0];
      const terminalStation = this.currentStations[this.currentStations.length - 1];
      
      // 替换基础占位符
      resolvedContent = resolvedContent.replace(/【当前站】/g, currentStation?.name || '当前站');
      resolvedContent = resolvedContent.replace(/【起点站】/g, firstStation?.name || '起点站');
      resolvedContent = resolvedContent.replace(/【终点站】/g, terminalStation?.name || '终点站');
      resolvedContent = resolvedContent.replace(/【副站名】/g, currentStation?.aliasName || currentStation?.name || '副站名');
      
      // 替换多语言占位符
      if (this.languageSettings && this.languageSettings.enabled && this.languageSettings.languages) {
        this.languageSettings.languages.forEach(lang => {
          if (lang.code !== 'zh') {
            const langName = lang.name;
            
            // 当前站多语言
            const currentStationLang = currentStation?.multiLanguageNames?.[lang.code] || currentStation?.name || '当前站';
            resolvedContent = resolvedContent.replace(new RegExp(`【当前站\\(${langName}\\)】`, 'g'), currentStationLang);
            
            // 起点站多语言
            const firstStationLang = firstStation?.multiLanguageNames?.[lang.code] || firstStation?.name || '起点站';
            resolvedContent = resolvedContent.replace(new RegExp(`【起点站\\(${langName}\\)】`, 'g'), firstStationLang);
            
            // 终点站多语言
            const terminalStationLang = terminalStation?.multiLanguageNames?.[lang.code] || terminalStation?.name || '终点站';
            resolvedContent = resolvedContent.replace(new RegExp(`【终点站\\(${langName}\\)】`, 'g'), terminalStationLang);
          }
        });
      }
      
      // 替换文件夹占位符（例如：【文件夹名-当前站】）
      resolvedContent = resolvedContent.replace(/【([^】]+)-当前站】/g, (match, folderName) => {
        return currentStation?.name || '当前站';
      });
      
      resolvedContent = resolvedContent.replace(/【([^】]+)-起点站】/g, (match, folderName) => {
        return firstStation?.name || '起点站';
      });
      
      resolvedContent = resolvedContent.replace(/【([^】]+)-终点站】/g, (match, folderName) => {
        return terminalStation?.name || '终点站';
      });
      
      return resolvedContent;
    }
  }
};
</script>

<style scoped>
.station-config-panel {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 15px;
  background-color: white;
}

.audio-list {
  max-height: 300px;
  overflow-y: auto;
}

.folder-buttons .btn {
  transition: all 0.2s ease;
}

.folder-buttons .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.folder-buttons .btn.active {
  background-color: #0d6efd;
  color: white;
  border-color: #0d6efd;
}

.audio-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.audio-item:last-child {
  border-bottom: none;
}

.audio-item audio {
  width: 200px;
  height: 30px;
}

.led-preview {
  font-family: 'Courier New', monospace;
  background-color: #000;
  color: #00ff00;
  padding: 4px 8px;
  border-radius: 3px;
  font-size: 0.9em;
  display: inline-block;
  min-width: 150px;
  text-align: center;
}
</style> 